import {
  getAuth,
  GithubAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { app } from "../../config/firebase.config";

import { motion } from "framer-motion";
import { validateLogin } from "../../api";
import { LoginHero } from "../../assets";
import { BsGithub, FaHome, FcGoogle } from "../../assets/icons";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import { buttonClick } from "../../utils/animations";

const Login = () => {
  const [isSignin, setIsSignin] = useState(true);
  const [{ user }, dispatch] = useStateValue();

  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();
  const github_provider = new GithubAuthProvider();
  const navigate = useNavigate();

  const loginWithGmail = async () => {
    await signInWithPopup(firebaseAuth, provider).then((userCred) => {
      firebaseAuth.onAuthStateChanged((userCred) => {
        if (userCred) {
          userCred.getIdToken().then((token) => {
            validateLogin(token).then((data) => {
              dispatch({
                type: actionType.SET_USER,
                user: data.data,
              });
            });
          });
          navigate("/", { replace: true });
        }
      });
    });
  };

  const loginWithGithub = async () => {
    await signInWithPopup(firebaseAuth, github_provider)
      .then((result) => {
        console.log(result);
        const cred = GithubAuthProvider.credentialFromResult(result);
        const token = cred.accessToken;
        dispatch({
          type: actionType.SET_USER,
          user: cred.user,
        });
        navigate("/", { replace: true });
      })
      .catch((er) => {
        console.log(er);
      });
  };

  return (
    <div className="w-full min-h-screen max-h-screen overflow-hidden grid grid-cols-1 md:grid-cols-2">
      <div className="p-12 flex flex-col justify-center items-center">
        <NavLink to={"/"}>
          <FaHome className=" -rotate-0 text-4xl text-textColor fixed top-8 left-8" />
        </NavLink>
        <div className="w-full md:w-350 flex flex-col items-center justify-center">
          <p className="text-3xl text-center font-semibold text-headingColor">
            Welcome Back
            <span className="block text-sm text-textColor">
              {isSignin ? "Sign in" : "Sign Up"} with following
            </span>
          </p>

          <motion.div
            {...buttonClick}
            className="w-full flex items-center justify-center gap-4 px-6 py-3 rounded-lg border border-gray-300 my-10 hover:shadow-lg cursor-pointer"
            onClick={loginWithGmail}
          >
            <FcGoogle className="text-2xl" />
            <p className="text-lg text-textColor">
              {isSignin ? "Sign in" : "Sign Up"} with Gmail
            </p>
          </motion.div>

          <motion.div
            {...buttonClick}
            className="w-full flex items-center justify-center gap-4 px-6 py-3 rounded-lg border border-gray-300 mb-10 hover:shadow-lg cursor-pointer"
            onClick={loginWithGithub}
          >
            <BsGithub className="text-2xl" />
            <p className="text-lg text-textColor">
              {isSignin ? "Sign in" : "Sign Up"} with Github
            </p>
          </motion.div>

          <p className="text-sm text-textColor">
            {isSignin ? "Doesn't have an account " : " Already a member "}

            <span
              className="underline cursor-pointer text-pink-600"
              onClick={() => setIsSignin(!isSignin)}
            >
              {isSignin ? "Signup" : "Signin"}
            </span>
          </p>
        </div>
      </div>
      <div className="hidden md:flex items-center justify-center relative">
        <img src={LoginHero} alt="" className="w-full h-screen object-cover" />
        <div className=" w-10/12 p-4 backdrop-blur-md flex items-start justify-center flex-col absolute bottom-8 rounded-md shadow-md bg-darkOverlay gap-6">
          <p className="text-md text-center text-primary tracking-wider">
            We are delighted to have you among us. On behalf of all the members
            and the management, we would like to extend our warmest welcome and
            good wishes!
          </p>
          <p className="text-2xl px-12 text-primary text-left ml-auto">
            - Vetrivel Ravi
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
